/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppCodesRouteImport } from './routes/_app/codes'
import { Route as AppHomeRouteImport } from './routes/_app/home'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppSearchTermsRouteRouteImport } from './routes/_app/search-terms/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthLoginLinkRouteImport } from './routes/_auth/login-link'
import { Route as AppBooksIndexRouteImport } from './routes/_app/books/index'
import { Route as AppBooksProductIdRouteImport } from './routes/_app/books/$productId'
import { Route as AppManuscriptsIndexRouteImport } from './routes/_app/manuscripts/index'
import { Route as AppManuscriptsProductIdRouteImport } from './routes/_app/manuscripts/$productId'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsProjectIdRouteRouteImport } from './routes/_app/projects/$projectId/route'
import { Route as AppSearchTermsIndexRouteImport } from './routes/_app/search-terms/index'
import { Route as AppSearchTermsAmazonRouteImport } from './routes/_app/search-terms/amazon'
import { Route as AppSearchTermsSelectedBooksRouteImport } from './routes/_app/search-terms/selected-books'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsOrganisationsRouteRouteImport } from './routes/_app/settings/organisations/route'
import { Route as AppProjectsProjectIdIndexRouteImport } from './routes/_app/projects/$projectId/index'
import { Route as AppSettingsOrganisationsIndexRouteImport } from './routes/_app/settings/organisations/index'
import { Route as AppSettingsOrganisationsOrganisationIdRouteRouteImport } from './routes/_app/settings/organisations/$organisationId/route'
import { Route as AppProjectsProjectIdProductProductIdRouteImport } from './routes/_app/projects/$projectId/product/$productId'
import { Route as AppSettingsOrganisationsOrganisationIdIndexRouteImport } from './routes/_app/settings/organisations/$organisationId/index'
import { Route as AppSettingsOrganisationsOrganisationIdManuscriptProcessingRouteImport } from './routes/_app/settings/organisations/$organisationId/manuscript-processing'
import { Route as AppSettingsOrganisationsOrganisationIdMembersRouteImport } from './routes/_app/settings/organisations/$organisationId/members'
import { Route as AppSettingsOrganisationsOrganisationIdStatusRouteImport } from './routes/_app/settings/organisations/$organisationId/status'
import { Route as AppSettingsOrganisationsOrganisationIdExportsIndexRouteImport } from './routes/_app/settings/organisations/$organisationId/exports/index'
import { Route as AppSettingsOrganisationsOrganisationIdExportsManualRouteImport } from './routes/_app/settings/organisations/$organisationId/exports/manual'
import { Route as AppSettingsOrganisationsOrganisationIdOnixUploadIndexRouteImport } from './routes/_app/settings/organisations/$organisationId/onix-upload/index'
import { Route as AppSettingsOrganisationsOrganisationIdOnixUploadFtpRouteImport } from './routes/_app/settings/organisations/$organisationId/onix-upload/ftp'
import { Route as AppSettingsOrganisationsOrganisationIdOnixUploadManualRouteImport } from './routes/_app/settings/organisations/$organisationId/onix-upload/manual'
import { Route as AppSettingsOrganisationsOrganisationIdSettingsIndexRouteImport } from './routes/_app/settings/organisations/$organisationId/settings/index'
import { Route as AppSettingsOrganisationsOrganisationIdSettingsProductAvailabilityRouteImport } from './routes/_app/settings/organisations/$organisationId/settings/product-availability'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactUsRoute = ContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCodesRoute = AppCodesRouteImport.update({
  id: '/codes',
  path: '/codes',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHomeRoute = AppHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSearchTermsRouteRoute = AppSearchTermsRouteRouteImport.update({
  id: '/search-terms',
  path: '/search-terms',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginLinkRoute = AuthLoginLinkRouteImport.update({
  id: '/login-link',
  path: '/login-link',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppBooksIndexRoute = AppBooksIndexRouteImport.update({
  id: '/books/',
  path: '/books/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBooksProductIdRoute = AppBooksProductIdRouteImport.update({
  id: '/books/$productId',
  path: '/books/$productId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppManuscriptsIndexRoute = AppManuscriptsIndexRouteImport.update({
  id: '/manuscripts/',
  path: '/manuscripts/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppManuscriptsProductIdRoute = AppManuscriptsProductIdRouteImport.update({
  id: '/manuscripts/$productId',
  path: '/manuscripts/$productId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProjectsProjectIdRouteRoute =
  AppProjectsProjectIdRouteRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSearchTermsIndexRoute = AppSearchTermsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSearchTermsRouteRoute,
} as any)
const AppSearchTermsAmazonRoute = AppSearchTermsAmazonRouteImport.update({
  id: '/amazon',
  path: '/amazon',
  getParentRoute: () => AppSearchTermsRouteRoute,
} as any)
const AppSearchTermsSelectedBooksRoute =
  AppSearchTermsSelectedBooksRouteImport.update({
    id: '/selected-books',
    path: '/selected-books',
    getParentRoute: () => AppSearchTermsRouteRoute,
  } as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOrganisationsRouteRoute =
  AppSettingsOrganisationsRouteRouteImport.update({
    id: '/organisations',
    path: '/organisations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppProjectsProjectIdIndexRoute =
  AppProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdRouteRoute,
  } as any)
const AppSettingsOrganisationsIndexRoute =
  AppSettingsOrganisationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsOrganisationsRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdRouteRoute =
  AppSettingsOrganisationsOrganisationIdRouteRouteImport.update({
    id: '/$organisationId',
    path: '/$organisationId',
    getParentRoute: () => AppSettingsOrganisationsRouteRoute,
  } as any)
const AppProjectsProjectIdProductProductIdRoute =
  AppProjectsProjectIdProductProductIdRouteImport.update({
    id: '/product/$productId',
    path: '/product/$productId',
    getParentRoute: () => AppProjectsProjectIdRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdIndexRoute =
  AppSettingsOrganisationsOrganisationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsOrganisationsOrganisationIdRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdManuscriptProcessingRoute =
  AppSettingsOrganisationsOrganisationIdManuscriptProcessingRouteImport.update({
    id: '/manuscript-processing',
    path: '/manuscript-processing',
    getParentRoute: () => AppSettingsOrganisationsOrganisationIdRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdMembersRoute =
  AppSettingsOrganisationsOrganisationIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppSettingsOrganisationsOrganisationIdRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdStatusRoute =
  AppSettingsOrganisationsOrganisationIdStatusRouteImport.update({
    id: '/status',
    path: '/status',
    getParentRoute: () => AppSettingsOrganisationsOrganisationIdRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdExportsIndexRoute =
  AppSettingsOrganisationsOrganisationIdExportsIndexRouteImport.update({
    id: '/exports/',
    path: '/exports/',
    getParentRoute: () => AppSettingsOrganisationsOrganisationIdRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdExportsManualRoute =
  AppSettingsOrganisationsOrganisationIdExportsManualRouteImport.update({
    id: '/exports/manual',
    path: '/exports/manual',
    getParentRoute: () => AppSettingsOrganisationsOrganisationIdRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdOnixUploadIndexRoute =
  AppSettingsOrganisationsOrganisationIdOnixUploadIndexRouteImport.update({
    id: '/onix-upload/',
    path: '/onix-upload/',
    getParentRoute: () => AppSettingsOrganisationsOrganisationIdRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdOnixUploadFtpRoute =
  AppSettingsOrganisationsOrganisationIdOnixUploadFtpRouteImport.update({
    id: '/onix-upload/ftp',
    path: '/onix-upload/ftp',
    getParentRoute: () => AppSettingsOrganisationsOrganisationIdRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdOnixUploadManualRoute =
  AppSettingsOrganisationsOrganisationIdOnixUploadManualRouteImport.update({
    id: '/onix-upload/manual',
    path: '/onix-upload/manual',
    getParentRoute: () => AppSettingsOrganisationsOrganisationIdRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdSettingsIndexRoute =
  AppSettingsOrganisationsOrganisationIdSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AppSettingsOrganisationsOrganisationIdRouteRoute,
  } as any)
const AppSettingsOrganisationsOrganisationIdSettingsProductAvailabilityRoute =
  AppSettingsOrganisationsOrganisationIdSettingsProductAvailabilityRouteImport.update(
    {
      id: '/settings/product-availability',
      path: '/settings/product-availability',
      getParentRoute: () => AppSettingsOrganisationsOrganisationIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/contact-us': typeof ContactUsRoute
  '/search-terms': typeof AppSearchTermsRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/codes': typeof AppCodesRoute
  '/home': typeof AppHomeRoute
  '/profile': typeof AppProfileRoute
  '/login': typeof AuthLoginRoute
  '/login-link': typeof AuthLoginLinkRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRouteRouteWithChildren
  '/settings/organisations': typeof AppSettingsOrganisationsRouteRouteWithChildren
  '/books/$productId': typeof AppBooksProductIdRoute
  '/manuscripts/$productId': typeof AppManuscriptsProductIdRoute
  '/search-terms/amazon': typeof AppSearchTermsAmazonRoute
  '/search-terms/selected-books': typeof AppSearchTermsSelectedBooksRoute
  '/books/': typeof AppBooksIndexRoute
  '/manuscripts/': typeof AppManuscriptsIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/search-terms/': typeof AppSearchTermsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/settings/organisations/$organisationId': typeof AppSettingsOrganisationsOrganisationIdRouteRouteWithChildren
  '/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
  '/settings/organisations/': typeof AppSettingsOrganisationsIndexRoute
  '/projects/$projectId/product/$productId': typeof AppProjectsProjectIdProductProductIdRoute
  '/settings/organisations/$organisationId/manuscript-processing': typeof AppSettingsOrganisationsOrganisationIdManuscriptProcessingRoute
  '/settings/organisations/$organisationId/members': typeof AppSettingsOrganisationsOrganisationIdMembersRoute
  '/settings/organisations/$organisationId/status': typeof AppSettingsOrganisationsOrganisationIdStatusRoute
  '/settings/organisations/$organisationId/': typeof AppSettingsOrganisationsOrganisationIdIndexRoute
  '/settings/organisations/$organisationId/exports/manual': typeof AppSettingsOrganisationsOrganisationIdExportsManualRoute
  '/settings/organisations/$organisationId/onix-upload/ftp': typeof AppSettingsOrganisationsOrganisationIdOnixUploadFtpRoute
  '/settings/organisations/$organisationId/onix-upload/manual': typeof AppSettingsOrganisationsOrganisationIdOnixUploadManualRoute
  '/settings/organisations/$organisationId/settings/product-availability': typeof AppSettingsOrganisationsOrganisationIdSettingsProductAvailabilityRoute
  '/settings/organisations/$organisationId/exports/': typeof AppSettingsOrganisationsOrganisationIdExportsIndexRoute
  '/settings/organisations/$organisationId/onix-upload/': typeof AppSettingsOrganisationsOrganisationIdOnixUploadIndexRoute
  '/settings/organisations/$organisationId/settings/': typeof AppSettingsOrganisationsOrganisationIdSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/contact-us': typeof ContactUsRoute
  '/codes': typeof AppCodesRoute
  '/home': typeof AppHomeRoute
  '/profile': typeof AppProfileRoute
  '/login': typeof AuthLoginRoute
  '/login-link': typeof AuthLoginLinkRoute
  '/books/$productId': typeof AppBooksProductIdRoute
  '/manuscripts/$productId': typeof AppManuscriptsProductIdRoute
  '/search-terms/amazon': typeof AppSearchTermsAmazonRoute
  '/search-terms/selected-books': typeof AppSearchTermsSelectedBooksRoute
  '/books': typeof AppBooksIndexRoute
  '/manuscripts': typeof AppManuscriptsIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/search-terms': typeof AppSearchTermsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/projects/$projectId': typeof AppProjectsProjectIdIndexRoute
  '/settings/organisations': typeof AppSettingsOrganisationsIndexRoute
  '/projects/$projectId/product/$productId': typeof AppProjectsProjectIdProductProductIdRoute
  '/settings/organisations/$organisationId/manuscript-processing': typeof AppSettingsOrganisationsOrganisationIdManuscriptProcessingRoute
  '/settings/organisations/$organisationId/members': typeof AppSettingsOrganisationsOrganisationIdMembersRoute
  '/settings/organisations/$organisationId/status': typeof AppSettingsOrganisationsOrganisationIdStatusRoute
  '/settings/organisations/$organisationId': typeof AppSettingsOrganisationsOrganisationIdIndexRoute
  '/settings/organisations/$organisationId/exports/manual': typeof AppSettingsOrganisationsOrganisationIdExportsManualRoute
  '/settings/organisations/$organisationId/onix-upload/ftp': typeof AppSettingsOrganisationsOrganisationIdOnixUploadFtpRoute
  '/settings/organisations/$organisationId/onix-upload/manual': typeof AppSettingsOrganisationsOrganisationIdOnixUploadManualRoute
  '/settings/organisations/$organisationId/settings/product-availability': typeof AppSettingsOrganisationsOrganisationIdSettingsProductAvailabilityRoute
  '/settings/organisations/$organisationId/exports': typeof AppSettingsOrganisationsOrganisationIdExportsIndexRoute
  '/settings/organisations/$organisationId/onix-upload': typeof AppSettingsOrganisationsOrganisationIdOnixUploadIndexRoute
  '/settings/organisations/$organisationId/settings': typeof AppSettingsOrganisationsOrganisationIdSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_auth': typeof AuthRouteRouteWithChildren
  '/contact-us': typeof ContactUsRoute
  '/_app/search-terms': typeof AppSearchTermsRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/codes': typeof AppCodesRoute
  '/_app/home': typeof AppHomeRoute
  '/_app/profile': typeof AppProfileRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/login-link': typeof AuthLoginLinkRoute
  '/_app/': typeof AppIndexRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRouteRouteWithChildren
  '/_app/settings/organisations': typeof AppSettingsOrganisationsRouteRouteWithChildren
  '/_app/books/$productId': typeof AppBooksProductIdRoute
  '/_app/manuscripts/$productId': typeof AppManuscriptsProductIdRoute
  '/_app/search-terms/amazon': typeof AppSearchTermsAmazonRoute
  '/_app/search-terms/selected-books': typeof AppSearchTermsSelectedBooksRoute
  '/_app/books/': typeof AppBooksIndexRoute
  '/_app/manuscripts/': typeof AppManuscriptsIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/search-terms/': typeof AppSearchTermsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/settings/organisations/$organisationId': typeof AppSettingsOrganisationsOrganisationIdRouteRouteWithChildren
  '/_app/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
  '/_app/settings/organisations/': typeof AppSettingsOrganisationsIndexRoute
  '/_app/projects/$projectId/product/$productId': typeof AppProjectsProjectIdProductProductIdRoute
  '/_app/settings/organisations/$organisationId/manuscript-processing': typeof AppSettingsOrganisationsOrganisationIdManuscriptProcessingRoute
  '/_app/settings/organisations/$organisationId/members': typeof AppSettingsOrganisationsOrganisationIdMembersRoute
  '/_app/settings/organisations/$organisationId/status': typeof AppSettingsOrganisationsOrganisationIdStatusRoute
  '/_app/settings/organisations/$organisationId/': typeof AppSettingsOrganisationsOrganisationIdIndexRoute
  '/_app/settings/organisations/$organisationId/exports/manual': typeof AppSettingsOrganisationsOrganisationIdExportsManualRoute
  '/_app/settings/organisations/$organisationId/onix-upload/ftp': typeof AppSettingsOrganisationsOrganisationIdOnixUploadFtpRoute
  '/_app/settings/organisations/$organisationId/onix-upload/manual': typeof AppSettingsOrganisationsOrganisationIdOnixUploadManualRoute
  '/_app/settings/organisations/$organisationId/settings/product-availability': typeof AppSettingsOrganisationsOrganisationIdSettingsProductAvailabilityRoute
  '/_app/settings/organisations/$organisationId/exports/': typeof AppSettingsOrganisationsOrganisationIdExportsIndexRoute
  '/_app/settings/organisations/$organisationId/onix-upload/': typeof AppSettingsOrganisationsOrganisationIdOnixUploadIndexRoute
  '/_app/settings/organisations/$organisationId/settings/': typeof AppSettingsOrganisationsOrganisationIdSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contact-us'
    | '/search-terms'
    | '/settings'
    | '/codes'
    | '/home'
    | '/profile'
    | '/login'
    | '/login-link'
    | '/projects/$projectId'
    | '/settings/organisations'
    | '/books/$productId'
    | '/manuscripts/$productId'
    | '/search-terms/amazon'
    | '/search-terms/selected-books'
    | '/books/'
    | '/manuscripts/'
    | '/projects/'
    | '/search-terms/'
    | '/settings/'
    | '/settings/organisations/$organisationId'
    | '/projects/$projectId/'
    | '/settings/organisations/'
    | '/projects/$projectId/product/$productId'
    | '/settings/organisations/$organisationId/manuscript-processing'
    | '/settings/organisations/$organisationId/members'
    | '/settings/organisations/$organisationId/status'
    | '/settings/organisations/$organisationId/'
    | '/settings/organisations/$organisationId/exports/manual'
    | '/settings/organisations/$organisationId/onix-upload/ftp'
    | '/settings/organisations/$organisationId/onix-upload/manual'
    | '/settings/organisations/$organisationId/settings/product-availability'
    | '/settings/organisations/$organisationId/exports/'
    | '/settings/organisations/$organisationId/onix-upload/'
    | '/settings/organisations/$organisationId/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contact-us'
    | '/codes'
    | '/home'
    | '/profile'
    | '/login'
    | '/login-link'
    | '/books/$productId'
    | '/manuscripts/$productId'
    | '/search-terms/amazon'
    | '/search-terms/selected-books'
    | '/books'
    | '/manuscripts'
    | '/projects'
    | '/search-terms'
    | '/settings'
    | '/projects/$projectId'
    | '/settings/organisations'
    | '/projects/$projectId/product/$productId'
    | '/settings/organisations/$organisationId/manuscript-processing'
    | '/settings/organisations/$organisationId/members'
    | '/settings/organisations/$organisationId/status'
    | '/settings/organisations/$organisationId'
    | '/settings/organisations/$organisationId/exports/manual'
    | '/settings/organisations/$organisationId/onix-upload/ftp'
    | '/settings/organisations/$organisationId/onix-upload/manual'
    | '/settings/organisations/$organisationId/settings/product-availability'
    | '/settings/organisations/$organisationId/exports'
    | '/settings/organisations/$organisationId/onix-upload'
    | '/settings/organisations/$organisationId/settings'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/contact-us'
    | '/_app/search-terms'
    | '/_app/settings'
    | '/_app/codes'
    | '/_app/home'
    | '/_app/profile'
    | '/_auth/login'
    | '/_auth/login-link'
    | '/_app/'
    | '/_app/projects/$projectId'
    | '/_app/settings/organisations'
    | '/_app/books/$productId'
    | '/_app/manuscripts/$productId'
    | '/_app/search-terms/amazon'
    | '/_app/search-terms/selected-books'
    | '/_app/books/'
    | '/_app/manuscripts/'
    | '/_app/projects/'
    | '/_app/search-terms/'
    | '/_app/settings/'
    | '/_app/settings/organisations/$organisationId'
    | '/_app/projects/$projectId/'
    | '/_app/settings/organisations/'
    | '/_app/projects/$projectId/product/$productId'
    | '/_app/settings/organisations/$organisationId/manuscript-processing'
    | '/_app/settings/organisations/$organisationId/members'
    | '/_app/settings/organisations/$organisationId/status'
    | '/_app/settings/organisations/$organisationId/'
    | '/_app/settings/organisations/$organisationId/exports/manual'
    | '/_app/settings/organisations/$organisationId/onix-upload/ftp'
    | '/_app/settings/organisations/$organisationId/onix-upload/manual'
    | '/_app/settings/organisations/$organisationId/settings/product-availability'
    | '/_app/settings/organisations/$organisationId/exports/'
    | '/_app/settings/organisations/$organisationId/onix-upload/'
    | '/_app/settings/organisations/$organisationId/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  ContactUsRoute: typeof ContactUsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/codes': {
      id: '/_app/codes'
      path: '/codes'
      fullPath: '/codes'
      preLoaderRoute: typeof AppCodesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/home': {
      id: '/_app/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/search-terms': {
      id: '/_app/search-terms'
      path: '/search-terms'
      fullPath: '/search-terms'
      preLoaderRoute: typeof AppSearchTermsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/login-link': {
      id: '/_auth/login-link'
      path: '/login-link'
      fullPath: '/login-link'
      preLoaderRoute: typeof AuthLoginLinkRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/books/': {
      id: '/_app/books/'
      path: '/books'
      fullPath: '/books/'
      preLoaderRoute: typeof AppBooksIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/books/$productId': {
      id: '/_app/books/$productId'
      path: '/books/$productId'
      fullPath: '/books/$productId'
      preLoaderRoute: typeof AppBooksProductIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/manuscripts/': {
      id: '/_app/manuscripts/'
      path: '/manuscripts'
      fullPath: '/manuscripts/'
      preLoaderRoute: typeof AppManuscriptsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/manuscripts/$productId': {
      id: '/_app/manuscripts/$productId'
      path: '/manuscripts/$productId'
      fullPath: '/manuscripts/$productId'
      preLoaderRoute: typeof AppManuscriptsProductIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/search-terms/': {
      id: '/_app/search-terms/'
      path: '/'
      fullPath: '/search-terms/'
      preLoaderRoute: typeof AppSearchTermsIndexRouteImport
      parentRoute: typeof AppSearchTermsRouteRoute
    }
    '/_app/search-terms/amazon': {
      id: '/_app/search-terms/amazon'
      path: '/amazon'
      fullPath: '/search-terms/amazon'
      preLoaderRoute: typeof AppSearchTermsAmazonRouteImport
      parentRoute: typeof AppSearchTermsRouteRoute
    }
    '/_app/search-terms/selected-books': {
      id: '/_app/search-terms/selected-books'
      path: '/selected-books'
      fullPath: '/search-terms/selected-books'
      preLoaderRoute: typeof AppSearchTermsSelectedBooksRouteImport
      parentRoute: typeof AppSearchTermsRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/organisations': {
      id: '/_app/settings/organisations'
      path: '/organisations'
      fullPath: '/settings/organisations'
      preLoaderRoute: typeof AppSettingsOrganisationsRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/projects/$projectId/': {
      id: '/_app/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AppProjectsProjectIdIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRouteRoute
    }
    '/_app/settings/organisations/': {
      id: '/_app/settings/organisations/'
      path: '/'
      fullPath: '/settings/organisations/'
      preLoaderRoute: typeof AppSettingsOrganisationsIndexRouteImport
      parentRoute: typeof AppSettingsOrganisationsRouteRoute
    }
    '/_app/settings/organisations/$organisationId': {
      id: '/_app/settings/organisations/$organisationId'
      path: '/$organisationId'
      fullPath: '/settings/organisations/$organisationId'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRouteImport
      parentRoute: typeof AppSettingsOrganisationsRouteRoute
    }
    '/_app/projects/$projectId/product/$productId': {
      id: '/_app/projects/$projectId/product/$productId'
      path: '/product/$productId'
      fullPath: '/projects/$projectId/product/$productId'
      preLoaderRoute: typeof AppProjectsProjectIdProductProductIdRouteImport
      parentRoute: typeof AppProjectsProjectIdRouteRoute
    }
    '/_app/settings/organisations/$organisationId/': {
      id: '/_app/settings/organisations/$organisationId/'
      path: '/'
      fullPath: '/settings/organisations/$organisationId/'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdIndexRouteImport
      parentRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRoute
    }
    '/_app/settings/organisations/$organisationId/manuscript-processing': {
      id: '/_app/settings/organisations/$organisationId/manuscript-processing'
      path: '/manuscript-processing'
      fullPath: '/settings/organisations/$organisationId/manuscript-processing'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdManuscriptProcessingRouteImport
      parentRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRoute
    }
    '/_app/settings/organisations/$organisationId/members': {
      id: '/_app/settings/organisations/$organisationId/members'
      path: '/members'
      fullPath: '/settings/organisations/$organisationId/members'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdMembersRouteImport
      parentRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRoute
    }
    '/_app/settings/organisations/$organisationId/status': {
      id: '/_app/settings/organisations/$organisationId/status'
      path: '/status'
      fullPath: '/settings/organisations/$organisationId/status'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdStatusRouteImport
      parentRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRoute
    }
    '/_app/settings/organisations/$organisationId/exports/': {
      id: '/_app/settings/organisations/$organisationId/exports/'
      path: '/exports'
      fullPath: '/settings/organisations/$organisationId/exports/'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdExportsIndexRouteImport
      parentRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRoute
    }
    '/_app/settings/organisations/$organisationId/exports/manual': {
      id: '/_app/settings/organisations/$organisationId/exports/manual'
      path: '/exports/manual'
      fullPath: '/settings/organisations/$organisationId/exports/manual'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdExportsManualRouteImport
      parentRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRoute
    }
    '/_app/settings/organisations/$organisationId/onix-upload/': {
      id: '/_app/settings/organisations/$organisationId/onix-upload/'
      path: '/onix-upload'
      fullPath: '/settings/organisations/$organisationId/onix-upload/'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdOnixUploadIndexRouteImport
      parentRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRoute
    }
    '/_app/settings/organisations/$organisationId/onix-upload/ftp': {
      id: '/_app/settings/organisations/$organisationId/onix-upload/ftp'
      path: '/onix-upload/ftp'
      fullPath: '/settings/organisations/$organisationId/onix-upload/ftp'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdOnixUploadFtpRouteImport
      parentRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRoute
    }
    '/_app/settings/organisations/$organisationId/onix-upload/manual': {
      id: '/_app/settings/organisations/$organisationId/onix-upload/manual'
      path: '/onix-upload/manual'
      fullPath: '/settings/organisations/$organisationId/onix-upload/manual'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdOnixUploadManualRouteImport
      parentRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRoute
    }
    '/_app/settings/organisations/$organisationId/settings/': {
      id: '/_app/settings/organisations/$organisationId/settings/'
      path: '/settings'
      fullPath: '/settings/organisations/$organisationId/settings/'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdSettingsIndexRouteImport
      parentRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRoute
    }
    '/_app/settings/organisations/$organisationId/settings/product-availability': {
      id: '/_app/settings/organisations/$organisationId/settings/product-availability'
      path: '/settings/product-availability'
      fullPath: '/settings/organisations/$organisationId/settings/product-availability'
      preLoaderRoute: typeof AppSettingsOrganisationsOrganisationIdSettingsProductAvailabilityRouteImport
      parentRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRoute
    }
  }
}

interface AppSearchTermsRouteRouteChildren {
  AppSearchTermsAmazonRoute: typeof AppSearchTermsAmazonRoute
  AppSearchTermsSelectedBooksRoute: typeof AppSearchTermsSelectedBooksRoute
  AppSearchTermsIndexRoute: typeof AppSearchTermsIndexRoute
}

const AppSearchTermsRouteRouteChildren: AppSearchTermsRouteRouteChildren = {
  AppSearchTermsAmazonRoute: AppSearchTermsAmazonRoute,
  AppSearchTermsSelectedBooksRoute: AppSearchTermsSelectedBooksRoute,
  AppSearchTermsIndexRoute: AppSearchTermsIndexRoute,
}

const AppSearchTermsRouteRouteWithChildren =
  AppSearchTermsRouteRoute._addFileChildren(AppSearchTermsRouteRouteChildren)

interface AppSettingsOrganisationsOrganisationIdRouteRouteChildren {
  AppSettingsOrganisationsOrganisationIdManuscriptProcessingRoute: typeof AppSettingsOrganisationsOrganisationIdManuscriptProcessingRoute
  AppSettingsOrganisationsOrganisationIdMembersRoute: typeof AppSettingsOrganisationsOrganisationIdMembersRoute
  AppSettingsOrganisationsOrganisationIdStatusRoute: typeof AppSettingsOrganisationsOrganisationIdStatusRoute
  AppSettingsOrganisationsOrganisationIdIndexRoute: typeof AppSettingsOrganisationsOrganisationIdIndexRoute
  AppSettingsOrganisationsOrganisationIdExportsManualRoute: typeof AppSettingsOrganisationsOrganisationIdExportsManualRoute
  AppSettingsOrganisationsOrganisationIdOnixUploadFtpRoute: typeof AppSettingsOrganisationsOrganisationIdOnixUploadFtpRoute
  AppSettingsOrganisationsOrganisationIdOnixUploadManualRoute: typeof AppSettingsOrganisationsOrganisationIdOnixUploadManualRoute
  AppSettingsOrganisationsOrganisationIdSettingsProductAvailabilityRoute: typeof AppSettingsOrganisationsOrganisationIdSettingsProductAvailabilityRoute
  AppSettingsOrganisationsOrganisationIdExportsIndexRoute: typeof AppSettingsOrganisationsOrganisationIdExportsIndexRoute
  AppSettingsOrganisationsOrganisationIdOnixUploadIndexRoute: typeof AppSettingsOrganisationsOrganisationIdOnixUploadIndexRoute
  AppSettingsOrganisationsOrganisationIdSettingsIndexRoute: typeof AppSettingsOrganisationsOrganisationIdSettingsIndexRoute
}

const AppSettingsOrganisationsOrganisationIdRouteRouteChildren: AppSettingsOrganisationsOrganisationIdRouteRouteChildren =
  {
    AppSettingsOrganisationsOrganisationIdManuscriptProcessingRoute:
      AppSettingsOrganisationsOrganisationIdManuscriptProcessingRoute,
    AppSettingsOrganisationsOrganisationIdMembersRoute:
      AppSettingsOrganisationsOrganisationIdMembersRoute,
    AppSettingsOrganisationsOrganisationIdStatusRoute:
      AppSettingsOrganisationsOrganisationIdStatusRoute,
    AppSettingsOrganisationsOrganisationIdIndexRoute:
      AppSettingsOrganisationsOrganisationIdIndexRoute,
    AppSettingsOrganisationsOrganisationIdExportsManualRoute:
      AppSettingsOrganisationsOrganisationIdExportsManualRoute,
    AppSettingsOrganisationsOrganisationIdOnixUploadFtpRoute:
      AppSettingsOrganisationsOrganisationIdOnixUploadFtpRoute,
    AppSettingsOrganisationsOrganisationIdOnixUploadManualRoute:
      AppSettingsOrganisationsOrganisationIdOnixUploadManualRoute,
    AppSettingsOrganisationsOrganisationIdSettingsProductAvailabilityRoute:
      AppSettingsOrganisationsOrganisationIdSettingsProductAvailabilityRoute,
    AppSettingsOrganisationsOrganisationIdExportsIndexRoute:
      AppSettingsOrganisationsOrganisationIdExportsIndexRoute,
    AppSettingsOrganisationsOrganisationIdOnixUploadIndexRoute:
      AppSettingsOrganisationsOrganisationIdOnixUploadIndexRoute,
    AppSettingsOrganisationsOrganisationIdSettingsIndexRoute:
      AppSettingsOrganisationsOrganisationIdSettingsIndexRoute,
  }

const AppSettingsOrganisationsOrganisationIdRouteRouteWithChildren =
  AppSettingsOrganisationsOrganisationIdRouteRoute._addFileChildren(
    AppSettingsOrganisationsOrganisationIdRouteRouteChildren,
  )

interface AppSettingsOrganisationsRouteRouteChildren {
  AppSettingsOrganisationsOrganisationIdRouteRoute: typeof AppSettingsOrganisationsOrganisationIdRouteRouteWithChildren
  AppSettingsOrganisationsIndexRoute: typeof AppSettingsOrganisationsIndexRoute
}

const AppSettingsOrganisationsRouteRouteChildren: AppSettingsOrganisationsRouteRouteChildren =
  {
    AppSettingsOrganisationsOrganisationIdRouteRoute:
      AppSettingsOrganisationsOrganisationIdRouteRouteWithChildren,
    AppSettingsOrganisationsIndexRoute: AppSettingsOrganisationsIndexRoute,
  }

const AppSettingsOrganisationsRouteRouteWithChildren =
  AppSettingsOrganisationsRouteRoute._addFileChildren(
    AppSettingsOrganisationsRouteRouteChildren,
  )

interface AppSettingsRouteRouteChildren {
  AppSettingsOrganisationsRouteRoute: typeof AppSettingsOrganisationsRouteRouteWithChildren
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsOrganisationsRouteRoute:
    AppSettingsOrganisationsRouteRouteWithChildren,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppProjectsProjectIdRouteRouteChildren {
  AppProjectsProjectIdIndexRoute: typeof AppProjectsProjectIdIndexRoute
  AppProjectsProjectIdProductProductIdRoute: typeof AppProjectsProjectIdProductProductIdRoute
}

const AppProjectsProjectIdRouteRouteChildren: AppProjectsProjectIdRouteRouteChildren =
  {
    AppProjectsProjectIdIndexRoute: AppProjectsProjectIdIndexRoute,
    AppProjectsProjectIdProductProductIdRoute:
      AppProjectsProjectIdProductProductIdRoute,
  }

const AppProjectsProjectIdRouteRouteWithChildren =
  AppProjectsProjectIdRouteRoute._addFileChildren(
    AppProjectsProjectIdRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppSearchTermsRouteRoute: typeof AppSearchTermsRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppCodesRoute: typeof AppCodesRoute
  AppHomeRoute: typeof AppHomeRoute
  AppProfileRoute: typeof AppProfileRoute
  AppIndexRoute: typeof AppIndexRoute
  AppProjectsProjectIdRouteRoute: typeof AppProjectsProjectIdRouteRouteWithChildren
  AppBooksProductIdRoute: typeof AppBooksProductIdRoute
  AppManuscriptsProductIdRoute: typeof AppManuscriptsProductIdRoute
  AppBooksIndexRoute: typeof AppBooksIndexRoute
  AppManuscriptsIndexRoute: typeof AppManuscriptsIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppSearchTermsRouteRoute: AppSearchTermsRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppCodesRoute: AppCodesRoute,
  AppHomeRoute: AppHomeRoute,
  AppProfileRoute: AppProfileRoute,
  AppIndexRoute: AppIndexRoute,
  AppProjectsProjectIdRouteRoute: AppProjectsProjectIdRouteRouteWithChildren,
  AppBooksProductIdRoute: AppBooksProductIdRoute,
  AppManuscriptsProductIdRoute: AppManuscriptsProductIdRoute,
  AppBooksIndexRoute: AppBooksIndexRoute,
  AppManuscriptsIndexRoute: AppManuscriptsIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLoginLinkRoute: typeof AuthLoginLinkRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthLoginLinkRoute: AuthLoginLinkRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  ContactUsRoute: ContactUsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
